// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1FXUv","consentsList":"PatientConsents_consentsList__1mVHm","consentsListEmpty":"PatientConsents_consentsListEmpty__EvBU2"};